import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { I18nextProvider } from 'react-i18next';
import { HelmetProvider } from 'react-helmet-async';
import i18n from './i18n';
import { Provider } from 'react-redux';
import { store } from './store';
import { ThemeProviderWrapper } from './theme/ThemeContext';
import { AuthProvider } from './context/AuthContext';
import ProtectedRoute from './components/ProtectedRoute';
import './styles/global.css';

// Layout and Pages
import Layout from './components/Layout';
import Home from './pages/Home';
import Hotels from './pages/Hotels';
import HotelDetails from './pages/HotelDetails';
import HotelBooking from './pages/HotelBooking';
import Temples from './pages/Temples';
import Ghats from './pages/Ghats';
import TravelPlanner from './pages/TravelPlanner';
import Aarti from './pages/Aarti';
import Festivals from './pages/Festivals';
import Services from './pages/Services';
import Users from './pages/Users';
import { LoginPage, RegisterPage } from './pages/Auth';
import TermsAndConditions from './pages/Terms';
import PrivacyPolicy from './pages/Privacy';
import ContactPage from './pages/Contact';
import Gallery from './pages/Gallery';
import TempleDetails from './pages/Temples/TempleDetails';
import GhatDetails from './pages/Ghats/GhatDetails';
import Profile from './pages/Profile';
import EPuja from './pages/EPuja';
import PujaDetails from './pages/EPuja/PujaDetails';
import PujaBooking from './pages/EPuja/PujaBooking';
import PanditList from './pages/EPuja/PanditList';
import AdminDashboard from './components/AdminDashboard';
import StaffPortal from './pages/Staff';
import TempleTimings from './pages/TempleTimings';
import News from './pages/News';
import About from './pages/About';
import TravelGuide from './pages/TravelGuide';
import DarshanBooking from './pages/DarshanBooking';
import Seva from './pages/Seva';
import NotFound from './pages/NotFound';
import { ghatRoutes } from './routes/ghatRoutes';
import PageTracker from './components/Analytics/PageTracker';

function AppContent() {
  return (
    <>
      <PageTracker />
      <Routes>
        {/* Staff portal — standalone, no nav/footer */}
        <Route path="/staff" element={<ProtectedRoute><StaffPortal /></ProtectedRoute>} />

        {/* All other routes — wrapped in Layout */}
        <Route path="*" element={
          <div style={{ minHeight: '100vh' }}>
            <Layout>
              <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/temples" element={<Temples />} />
                <Route path="/temples/:slug" element={<TempleDetails />} />
                <Route path="/ghats" element={<Ghats />} />
                <Route path="/ghats/:ghatId" element={<GhatDetails routeData={ghatRoutes} />} />
                <Route path="/aarti" element={<Aarti />} />
                <Route path="/darshan-booking" element={<DarshanBooking />} />
                <Route path="/sugam-darshan" element={<Navigate to="/darshan-booking" replace />} />
                <Route path="/festivals" element={<Festivals />} />
                <Route path="/services" element={<Services />} />
                <Route path="/hotels" element={<Hotels />} />
                <Route path="/hotels/:id" element={<HotelDetails />} />
                <Route path="/epuja" element={<EPuja />} />
                <Route path="/epuja/:id" element={<PujaDetails />} />
                <Route path="/pandits" element={<PanditList />} />
                <Route path="/travel-planner" element={<TravelPlanner />} />
                <Route path="/temple-timings" element={<TempleTimings />} />
                <Route path="/news" element={<News />} />
                <Route path="/blog" element={<News />} />
                <Route path="/about" element={<About />} />
                <Route path="/travel-guide" element={<TravelGuide />} />
                <Route path="/seva" element={<Seva />} />
                <Route path="/gallery" element={<Gallery />} />
                <Route path="/contact" element={<ContactPage />} />
                <Route path="/terms" element={<TermsAndConditions />} />
                <Route path="/privacy" element={<PrivacyPolicy />} />
                <Route path="/login" element={<LoginPage />} />
                <Route path="/register" element={<RegisterPage />} />
                <Route path="/book-hotel/:id" element={<ProtectedRoute><HotelBooking /></ProtectedRoute>} />
                <Route path="/hotels/:id/booking" element={<ProtectedRoute><HotelBooking /></ProtectedRoute>} />
                <Route path="/epuja/:id/book" element={<ProtectedRoute><PujaBooking /></ProtectedRoute>} />
                <Route path="/users" element={<ProtectedRoute><Users /></ProtectedRoute>} />
                <Route path="/profile" element={<ProtectedRoute><Profile /></ProtectedRoute>} />
                <Route path="/admin" element={<ProtectedRoute><AdminDashboard /></ProtectedRoute>} />
                <Route path="*" element={<NotFound />} />
              </Routes>
            </Layout>
          </div>
        } />
      </Routes>
    </>
  );
}

function App() {
  return (
    <BrowserRouter>
      <Provider store={store}>
        <I18nextProvider i18n={i18n}>
          <HelmetProvider>
            <ThemeProviderWrapper>
              <AuthProvider>
                <AppContent />
              </AuthProvider>
            </ThemeProviderWrapper>
          </HelmetProvider>
        </I18nextProvider>
      </Provider>
    </BrowserRouter>
  );
}
export default App;
